import { useEffect } from 'react'
import type { Middleware } from 'openapi-fetch'

import { apiClient } from '~/api/client'
import type { paths } from '~/api/types'
import { LS_JWT_KEY } from '~/const/api'
import { useIsOnline } from '~/hooks/use-is-online'
import { useAccountStore } from '~/stores/account'

export const FreshAccount = () => {
  const revalidateAccount = useAccountStore(state => state.revalidateAccount)
  const isOnline = useIsOnline()

  useEffect(() => {
    // user isn't authenticated -> skip
    if (!localStorage.getItem(LS_JWT_KEY) || !isOnline) return

    void revalidateAccount()
  }, [revalidateAccount, isOnline])

  // actualize user on 403 response (eg not prolonged subscription)
  useEffect(() => {
    const middleware: Middleware = {
      onResponse: async ({ response }) => {
        const ME_URL: keyof paths = '/user/me'
        if (response.status === 403 && !response.url.includes(ME_URL)) void revalidateAccount()
      },
    }
    apiClient.use(middleware)

    return () => apiClient.eject(middleware)
  }, [revalidateAccount])

  useEffect(() => {
    if (!isOnline) return
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') void revalidateAccount()
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [revalidateAccount, isOnline])

  return null
}
